import styles from '@/styles/buying-guide/guide-item.module.scss'
import Link from 'next/link'
import Image from 'next/image'
import { Button } from 'antd';

interface GuideItemProps {
  type?: string;
  PopularBuyingGuidesData: {
    categoryID?: number;
    name: string;
    guideUrl: string;
    detailGuideUrl?: string;
    imgUrl: string;
    seoDescription: string | null;
  }
}

export default function PopularBuyingGuides(props: GuideItemProps) {
  return (
    <Link
      href={`${props.type == 'detail' ? props.PopularBuyingGuidesData.detailGuideUrl : props.PopularBuyingGuidesData.guideUrl}`}
      legacyBehavior
    >
      <a className={styles['comp-guide-item']} rel="noopener noreferrer">
        <Image
          className={styles['guide-item-image']}
          src={props.PopularBuyingGuidesData.imgUrl}
          alt={props.PopularBuyingGuidesData.name}
          width={200}
          height={200}
        />
        <div className={`${styles['guide-item-cate']} ${props.type == 'detail' ? styles['guide-item-cate-detail'] : ''}`}>{props.PopularBuyingGuidesData.name}</div>
        <div className={`${styles['guide-item-desc']} ${props.type == 'detail' ? styles['guide-item-desc-detail'] : ''}`}>{props.PopularBuyingGuidesData.seoDescription}</div>

        <Button type="primary" className={styles['guide-btn']}>View Guides</Button>
      </a>
    </Link>
  )
}